/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorSymptomDto } from '../../models/vendor-symptom-dto';

export interface AsControllerGetClientVisibleSymptoms$Params {
  clientWorkspaceId: string;
}

export function asControllerGetClientVisibleSymptoms(http: HttpClient, rootUrl: string, params: AsControllerGetClientVisibleSymptoms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorSymptomDto>>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetClientVisibleSymptoms.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorSymptomDto>>;
    })
  );
}

asControllerGetClientVisibleSymptoms.PATH = '/api/v1/as/client/{clientWorkspaceId}/symptoms';
